const plantWithoutStatInspChartData = state =>
  state.plantWithoutStatInspChartData;

const timedDefectStatusesChartData = state =>
  state.timedDefectStatusesChartData;

const untimedDefectStatusesChartData = state =>
  state.untimedDefectStatusesChartData;

const safedStatusesChartData = state => state.safedStatusesChartData;

const statInspStatusesChartData = state => state.statInspStatusesChartData;

const quoteMetric = state => state.quoteMetric;

export default {
  plantWithoutStatInspChartData,
  timedDefectStatusesChartData,
  untimedDefectStatusesChartData,
  safedStatusesChartData,
  statInspStatusesChartData,
  quoteMetric
};
